// src/api/favoritesApi.js
import axios from "../axios";

// Получить список избранных объявлений текущего пользователя
export async function fetchFavorites() {
  // Берём готовый экшен из AdViewSet: /api/ads/favorites/
  const res = await axios.get("/api/ads/favorites/");
  // Бэкенд возвращает СРАЗУ массив объявлений (Ad), как обычный /api/ads/
  return res.data;
}

// Переключить избранное для конкретного объявления
export async function toggleFavorite(adId) {
  // Используем /api/ads/{id}/toggle_favorite/
  const res = await axios.post(`/api/ads/${adId}/toggle_favorite/`);
  // ответ: { is_favorite: true/false }
  return res.data;
}
